// eslint-disable-next-line no-unused-vars
import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import Uploader from './Uploader';

const PhotoUploaderPicker = ({ resource, ...rest }) => {
  return pickFunction(resource, {
    [fr.relationships.profileImage.name]: () => {
      return (
        <Uploader {...rest} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default PhotoUploaderPicker;
